import React from 'react';
import { Circle, Group, Image as KonvaImage } from 'react-konva';
import useImage from 'use-image';
import TrashIcon from 'images/icon_trash.svg';
import PropTypes from 'prop-types';
import COLORS from 'utils/constants/colors';
const { PURPLE, WHITE } = COLORS;

const ResetButtonIcon = ({ deletePoints, deleteButtonref, x, y }) => {
  const [image] = useImage(TrashIcon);
  const CIRCLE_RADIUS = 20;
  return (
    <>
      <Group
        x={x}
        y={y}
        id={'index-key'}
        key={'index-key'}
        onClick={deletePoints}
      >
        <Circle
          radius={CIRCLE_RADIUS}
          fill={PURPLE}
          stroke={WHITE}
          strokeWidth={1}
        />
        <KonvaImage
          ref={deleteButtonref}
          image={image}
          height={x}
          width={y}
          offsetX={x / 2}
          offsetY={y / 2}
        />
      </Group>
    </>
  );
};
ResetButtonIcon.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  deletePoints: PropTypes.func,
  deleteButtonref: PropTypes.object,
};

export default ResetButtonIcon;
